export default __webpack_public_path__ + "static/media/undraw_Taken_if77.30918976.svg";